import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import Header from '../../../components/Editor/Header';
import { EditorType } from '../constants';
import { isEditablePage } from '../../../containers/Editor/selectors';
import UserAgentUtils from '../../../utils/userAgent';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			type,
			slider: { totalPages },
		},
	} = state;

	return {
		isButtonEditDisplayed: isEditablePage(state),
		isButtonRemoveDisplayed: totalPages > 1,
		isButtonPageSelectionDisplayed: UserAgentUtils.isTouchSupported() && totalPages > 1,
		isButtonDuplicateDisplayed: type === EditorType.INDESIGN,
	};
};

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/Header/index.tsx